export default __webpack_public_path__ + "e3d71ed614db8e12d6525b8019d0472e.png";